<mat-nav-list class="cycle-overview__list">
  <a
    href="#"
    mat-list-item
    class="cycle-overview-simple__item"
    data-test="cycle-overview-simple__item"
    *ngFor="let cycle of cycles$ | async"
    [routerLink]="['/cycle', cycle.id]"
  >
    <mat-icon matListItemAvatar class="list-avatar">loop</mat-icon>
    <h2 matListItemTitle>
      {{ 'cycle' | translate | titlecase }} {{ cycle.cycleNumber }} - {{ cycle.concept.name }} -
      {{ cycle.cycleDescription }}
    </h2>
    <p
      matListItemLine
      class="text--gray"
      [attr.data-test]="'cycle-overview-simple__cycle-number--' + cycle.cycleNumber"
    >
      {{ cycle.cycleDate | agrDate: 'dd-MM-yyyy' }} -
      {{ cycle.cycleEndDate | agrDate: 'dd-MM-yyyy' }}
    </p>
    <div matListItemMeta>
      <button mat-icon-button [matMenuTriggerFor]="detailMenu" (click)="openMenu($event)">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #detailMenu>
        <button mat-menu-item (click)="delete(cycle)" data-test="cycle-overview-simple__delete">
          <mat-icon>delete</mat-icon><span>{{ 'cycle-overview.delete-cycle' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </a>
</mat-nav-list>
